import { render, staticRenderFns } from "./ClientCompletedPage.vue?vue&type=template&id=7b99aa19"
import script from "./ClientCompletedPage.vue?vue&type=script&lang=js"
export * from "./ClientCompletedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports